<script setup lang="ts">
import { toRefs } from 'vue';
import { EMIT } from '@/enum';

interface PropsInterface {
  id?: number;
  open: boolean;
}
const emit = defineEmits([EMIT.CANCEL, EMIT.UPDATE]);
const props = defineProps<PropsInterface>();
const { open } = toRefs(props);

const onCancel = () => emit(EMIT.CANCEL);
const onRemove = () => emit(EMIT.UPDATE);
</script>

<template>
  <div>
    <ConfirmAction v-if="open" header="Remove Referral" accept-label="Remove" @accept="onRemove" @cancel="onCancel">
      <div class="flex text-gray-800 align-items-center">
        <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
        <span class="ml-3">Are you sure you want to remove this row?</span>
      </div>
    </ConfirmAction>
  </div>
</template>

<style scoped lang="scss">
.confirm-action {
  width: 396px !important;

  .p-dialog-header,
  .p-dialog-content {
    padding: 12px;
  }
}
</style>
